export default function () {
	let activeTooltip = null

	const closeTooltip = () => {
		if (activeTooltip) {
			activeTooltip.remove()
			activeTooltip = null
			document
				.querySelectorAll('.is-tooltip-active')
				.forEach((el) => el.classList.remove('is-tooltip-active'))
		}
	}

	document.addEventListener('click', (e) => {
		const trigger = e.target.closest('[data-block-tooltip-trigger]')

		if (trigger && trigger.classList.contains('tooltip-close-btn')) {
			closeTooltip()
			return
		}

		if (trigger) {
			e.preventDefault()

			const wrapper = trigger.closest('.text-with-icon-title')
			if (!wrapper) return

			if (wrapper.classList.contains('is-tooltip-active')) {
				closeTooltip()
				return
			}

			closeTooltip()

			const contentSource = wrapper.querySelector('[data-block-tooltip-content]')
			if (!contentSource) return

			wrapper.classList.add('is-tooltip-active')

			const rect = wrapper.getBoundingClientRect()
			const scrollLeft = document.documentElement.scrollLeft
			const scrollTop = document.documentElement.scrollTop

			const tooltipNode = document.createElement('div')
			tooltipNode.className = 'global-tooltip-portal'
			tooltipNode.innerHTML = contentSource.innerHTML

			tooltipNode.style.opacity = '0'
			tooltipNode.style.position = 'absolute'
			tooltipNode.style.top = '0px'
			tooltipNode.style.left = '0px'

			document.body.appendChild(tooltipNode)

			// OBLICZENIA KOLIZJI
			const tooltipRect = tooltipNode.getBoundingClientRect()
			const viewportWidth = window.innerWidth
			const gutter = 15

			let finalLeft = rect.left + scrollLeft - 10
			let finalTop = rect.top + scrollTop - 10

			if (rect.left + tooltipRect.width > viewportWidth - gutter) {
				finalLeft = viewportWidth + scrollLeft - tooltipRect.width - gutter
			}

			if (finalLeft < scrollLeft + gutter) {
				finalLeft = scrollLeft + gutter
			}

			tooltipNode.style.left = finalLeft + 'px'
			tooltipNode.style.top = finalTop + 'px'
			tooltipNode.style.opacity = ''
			activeTooltip = tooltipNode
			return
		}

		if (activeTooltip && !activeTooltip.contains(e.target)) {
			closeTooltip()
		}
	})

	window.addEventListener('scroll', closeTooltip, { passive: true })
	window.addEventListener('resize', closeTooltip)
}
